import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Dancing Script", cursive' }}>
              逐梦教育 BD Careers
            </h3>
            <p className="text-gray-300 mb-4 max-w-md">
              专注全球高价值高增长职业规划，提供求职、留学、移民全链路服务。逃离内卷，规划全球上升新职路。
            </p>
            <div className="flex space-x-4">
              <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-colors">
                <i className="ri-wechat-fill text-white"></i>
              </div>
              <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-colors">
                <i className="ri-qq-fill text-white"></i>
              </div>
              <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-colors">
                <i className="ri-linkedin-fill text-white"></i>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">服务项目</h4>
            <ul className="space-y-2">
              <li><Link to="/job" className="text-gray-300 hover:text-white transition-colors cursor-pointer">海内外求职</Link></li>
              <li><Link to="/study" className="text-gray-300 hover:text-white transition-colors cursor-pointer">留学申请</Link></li>
              <li><Link to="/immigration" className="text-gray-300 hover:text-white transition-colors cursor-pointer">移民规划</Link></li>
              <li><Link to="/#assessment" className="text-gray-300 hover:text-white transition-colors cursor-pointer">免费评估</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">联系我们</h4>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                +86 18917365881
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                contact@zhumengedu.com
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 逐梦教育 BD Careers. 保留所有权利。
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer mt-2 md:mt-0"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
